import React from 'react';
import * as S from './Footer.styles';

const FooterPartner = () => {
  return (
    <S.FooterOuterWrap>
      {/* <S.LogoWrapper>
        <IconSelector iconKey='partnerlogo' />
      </S.LogoWrapper> */}
      <S.FooterInnerWrap>
        <S.CopyRightText>&copy;{' ' + new Date().getFullYear() + ' MakeMyTrip (India) Limited'}</S.CopyRightText>
      </S.FooterInnerWrap>
    </S.FooterOuterWrap>
  );
}

export default FooterPartner;
